(function () {
    var bars = document.querySelectorAll('.top-alert');
    if (!bars.length) return;

    var SEVEN_DAYS = 7 * 86400000;
    var version = bars[0].dataset.version || '1';
    var storageKey = 'maverick_announcements_v' + version;
    var dismissed = JSON.parse(localStorage.getItem(storageKey) || '{}');

    // Reveal the first eligible announcement before paint (no layout jump);
    // leave the rest hidden.
    var shown = null;
    for (var i = 0; i < bars.length; i++) {
        var bar = bars[i];
        var ts = dismissed[bar.dataset.announcementId];
        var eligible = bar.dataset.forceShow === '1' || !ts || Date.now() - ts > SEVEN_DAYS;
        if (!eligible) continue;

        shown = bar;
        bar.style.display = '';
        if (window.innerWidth <= 992) {
            (function (b) {
                setTimeout(function () { b.classList.add('is-visible'); }, 1000);
            })(bar);
        }
        break;
    }

    if (!shown) return;

    var btn = shown.querySelector('button');
    if (!btn) return;

    btn.addEventListener('click', function () {
        var current = JSON.parse(localStorage.getItem(storageKey) || '{}');
        current[shown.dataset.announcementId] = Date.now();
        localStorage.setItem(storageKey, JSON.stringify(current));

        var cleanup = function () { shown.style.display = 'none'; };

        if (window.innerWidth <= 992) {
            shown.classList.remove('is-visible');
            if (window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
                shown.addEventListener('transitionend', cleanup, { once: true });
            } else {
                cleanup();
            }
        } else {
            cleanup();
        }
    });
})();
